module.exports = __webpack_public_path__ + "media/images/new_entry_free-2b294690da7ce96286148bed2a7a15c2.png";